import {gsap} from "../../../libs/gsap/all.js";
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras';
import {Point} from 'pixi.js';

// Constructor
export class GameE_Tag extends PIXI.Container {

  constructor(x, y, data, game) {
    super();

    this.game = game;
    this.data = data;

    this.id = this.data.id;
    this.droppedInZone = null;
    this.zIndex = 0;
    this.isValid = false;

    this.bgBaseAnimatedValue = {
      width: this.game.data.tagsSize.width,
      height: this.game.data.tagsSize.height,
      radius: this.game.data.tagsSize.height / 2,
    };

    this.position.set(x, y);

    // Tag text style
    this.tagTextStyle = new PIXI.TextStyle({
      align: "center",
      fill: "#00156B",
      fontFamily: "Sketchnote Text",
      fontSize: (typeof this.data.fontSize !== "undefined") ? this.data.fontSize : 24,
      wordWrap: true,
      wordWrapWidth: 400
    });

    this.build();
  }

  build() {
    this.background = new PIXI.Graphics().roundRect(0, 0, this.game.data.tagsSize.width, this.game.data.tagsSize.height, this.game.data.tagsSize.height / 2).fill(0xFFEB5A).stroke({
      width: 0,
      color: 0xFFFFFF
    });
    this.background.pivot.set(this.background.width / 2, this.background.height / 2);
    this.background.position.set(this.background.width / 2, this.background.height / 2);
    this.background.animatedValues = {...this.bgBaseAnimatedValue};
    this.addChild(this.background);

    this.tagTextEN = this.game.createInterfaceText(this.data.text["en"], {...this.tagTextStyle}, "en"); // use a copy of the baseButtonTextStyle so we can update them individually
    this.tagTextFR = this.game.createInterfaceText(this.data.text["fr"], {...this.tagTextStyle}, "fr"); // use a copy of the baseButtonTextStyle so we can update them individually
    this.tagTextEN.anchor.set(0.5); // center in box easier
    this.tagTextFR.anchor.set(0.5); // center in box easier
    this.tagTextEN.position.x = this.width / 2;
    this.tagTextFR.position.x = this.width / 2;
    this.tagTextEN.position.y = this.height / 2;
    this.tagTextFR.position.y = this.height / 2;

    this.addChild(this.tagTextEN);
    this.addChild(this.tagTextFR);

    this.pivot.set(this.width / 2, this.height / 2);

    this.originalPosition = new PIXI.Point().copyFrom(this.position); // copy original position to a variable for later

    this.generateBackgroundArea();
    this.buildAnimations();
  }

  enable() {
    this.eventMode = "static";
    this.cursor = 'grab';
  }

  disable() {
    this.eventMode = "none";
    this.cursor = 'static';
  }

  buildAnimations() {

    this.bgArea.alpha = 0;

    this.inAnimation = gsap.fromTo(this, {
        pixi: {
          y: this.originalPosition.y + 40,
          alpha: 0,
        },
      }, {
        pixi: {
          y: this.originalPosition.y,
          alpha: 1,
        },
        ease: "power1.out",
        immediateRender: true,
        paused: true,
        duration: 1,
        onComplete: () => {
          this.enable();
          this.bgArea.alpha = 1;
        }
      }
    );
  }

  animateIn() {
    if (this.inAnimation) {
      this.inAnimation.play();
    }
  }

  pickedUp() {
    this.alpha = 0.75;
    this.zIndex = 1;
    this.cursor = 'grabbing';
  }

  released() {
    this.alpha = 1;
    this.zIndex = 0;
    this.cursor = 'grab';
  }

  animateDropped(dropZone) {
    // set tag position to the dropzone position
    // const dropZoneGlobalPos = dropZone.toGlobal(new PIXI.Point(0, 0)); // get the global position for the dropzone
    // const dropZoneLocalTranslated = this.parent.toLocal(dropZoneGlobalPos); // convert it to the relative position of the tags container
    // console.log(dropZoneGlobalPos);
    // console.log(dropZoneLocalTranslated);

    gsap.killTweensOf(this);
    gsap.killTweensOf(this.background);
    // gsap.killTweensOf(this.background);

    // this.background.clear().roundRect(this.pivot.x, this.pivot.y, dropZone.width, dropZone.height, dropZone.height / 2).fill(0xFFEB5A);

    gsap.to(this, {
        pixi: {
          x: dropZone.position.x + dropZone.width / 2,
          y: dropZone.position.y + dropZone.height / 2,
        },
        ease: "quad.out",
        duration: 0.25,
      }
    )

    gsap.to(this.background.animatedValues, {
      width: dropZone.width, // Target width
      height: dropZone.height, // Target height
      radius: dropZone.height / 2,
      duration: 0.25,
      onUpdate: () => {
        // Clear and redraw the rectangle with new dimensions
        this.background.clear();
        this.background.roundRect(0, 0, this.background.animatedValues.width, this.background.animatedValues.height, this.background.animatedValues.radius).fill(0xFFEB5A).stroke({
          width: 0,
          color: 0xFFFFFF
        });

        this.background.pivot.set(this.background.animatedValues.width / 2, this.background.animatedValues.height / 2);
        this.background.position.set(this.background.animatedValues.width / 2, this.background.animatedValues.height / 2);

        this.pivot.set(this.background.animatedValues.width / 2, this.background.animatedValues.height / 2);

        this.tagTextEN.position.x = this.background.animatedValues.width / 2;
        this.tagTextFR.position.x = this.background.animatedValues.width / 2;
        this.tagTextEN.position.y = this.background.animatedValues.height / 2;
        this.tagTextFR.position.y = this.background.animatedValues.height / 2;
      },
    });

  }

  getBgArea() {
    return this.bgArea;
  }

  generateBackgroundArea() {
    let bgArea = new PIXI.Graphics().roundRect(0, 0, this.game.data.tagsSize.width, this.game.data.tagsSize.height, this.game.data.tagsSize.height / 2).fill({
      color: 0xF2F1D1,
      alpha: 0.5
    });
    bgArea.alpha = 0;
    bgArea.position.set(this.originalPosition.x, this.originalPosition.y);
    bgArea.pivot.set(bgArea.width / 2, bgArea.height / 2);
    this.bgArea = bgArea;
  }

  resetPosition(duration = 0.25) {
    gsap.killTweensOf(this);
    gsap.killTweensOf(this.background);

    gsap.to(this, {
        pixi: {
          x: this.originalPosition.x,
          y: this.originalPosition.y,
        },
        ease: "quad.out",
        duration: duration,
      }
    )

    gsap.to(this.background.animatedValues, {
      width: this.bgBaseAnimatedValue.width, // Target width
      height: this.bgBaseAnimatedValue.height, // Target height
      radius: this.bgBaseAnimatedValue.height / 2,
      duration: duration,
      onUpdate: () => {
        // Clear and redraw the rectangle with new dimensions
        this.background.clear();
        this.background.roundRect(0, 0, this.background.animatedValues.width, this.background.animatedValues.height, this.background.animatedValues.radius).fill(0xFFEB5A).stroke({
          width: 0,
          color: 0xFFFFFF
        });

        this.background.pivot.set(this.background.animatedValues.width / 2, this.background.animatedValues.height / 2);
        this.background.position.set(this.background.animatedValues.width / 2, this.background.animatedValues.height / 2);

        this.pivot.set(this.background.animatedValues.width / 2, this.background.animatedValues.height / 2);

        this.tagTextEN.position.x = this.background.animatedValues.width / 2;
        this.tagTextFR.position.x = this.background.animatedValues.width / 2;
        this.tagTextEN.position.y = this.background.animatedValues.height / 2;
        this.tagTextFR.position.y = this.background.animatedValues.height / 2;
      },
    });

  }

  resetState(duration) {
    this.resetPosition(duration);
    this.droppedInZone = null;
    this.isValid = false;
  }

  // Reset the states so we can animate in again and start over
  reset() {
    if (this.inAnimation) {
      this.inAnimation.kill();
      this.inAnimation = null;
    }

    this.resetState(0);

    // Rebuild the animations
    this.buildAnimations();
  }


}
